
import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';

export const Home = () => {
 
  const isDesktop = window.innerWidth >= 768; // example threshold for mobile screens

  useEffect(() => {
    if (isDesktop) {
      AOS.init();
    }
  }, [isDesktop]);

  const scrollToSection = (name) => {
  
    const element=document.getElementById(name);
    if(element){
      element.scrollIntoView({behavior:'smooth'})
    }
  };

  const Click=(url)=>{
    window.location.href=url;
  }
  
  useEffect(() => {
    const emailButton = document.getElementById("emailButton");
    if (emailButton) {
      emailButton.addEventListener("click", function () {
        window.location.href = "mailto:dhushyanthravichandran@gmail.com?subject=Subject%20Here&body=Hello%20Dhushyanth,";
      });
    }
});

  return (
    <div id="home">
      <div className="container">
         <span className="text first-text">Hi, I am </span><br/>
         <span className="text second-text">Pranav Suresh Bakare</span>
       
       </div>

   

      <div className="home-content">
        <p>
          Meticulous Oracle Developer with full-stack capabilities and 
          over 4 years of hands-on experience in PL/SQL, database optimization, 
          and high-performance application development. 
          Proficient in crafting and optimizing complex PL/SQL scripts. 
          Skilled in Python/Django, CI/CD automation (GitLab, Liquibase, Gradle), 
          and cloud ecosystems (AWS, GCP, Docker, Kubernetes) 
          to deliver secure, scalable end-to-end solutions
        </p>

        
      </div>
   
     
      <div className="arrow-down">
      <button  onClick={() => scrollToSection('about')} >
           <i className="fa-solid fa-angles-down" style={{ color: "#FFC107" }}></i>
      </button>
      </div>
      
    </div>
  );
};


